import { create } from "zustand";
import { getData } from "../utils/formHelpers";
import { DosimetrosListType } from "../../app/types/genericTables.types";

type useDosimetrosType = {
  dosimetrosList: DosimetrosListType[];
  get: (id: DosimetrosListType["id"]) => DosimetrosListType | undefined;
  query: string;
  setQuery: (query: string) => void;
  fetchAll: () => void;
  loading: boolean;
};

export const useDosimetros = create<useDosimetrosType>((set, get) => ({
  loading: false,
  dosimetrosList: [],
  query: "",
  setQuery: (query) => set({ query }),
  get: (id) => get().dosimetrosList.find((detector) => detector.id === id),
  fetchAll: async () => {
    set({ loading: true });
    try {
      const endpoint = "/generic/Dosimetros";
      const { data: response } = await getData(endpoint);
      set(() => ({
        dosimetrosList: response,
        loading: false,
      }));
    } catch (error) {
      console.error("Error fetching useDetector:", error);
      set({ loading: false });
    }
  },
}));
